module.exports = __webpack_public_path__ + "img/Doctrine.5b849014.png";